module.exports = __webpack_public_path__ + "static/media/moraine-47.8065c017.jpg";